import { api } from './core'

export const counselApi = {
  list: (page, type) => api.get('/medi/consult', { page, type }),
  detail: (_id) => api.get('/medi/consult/single', { _id }),
  saveAnswer: (params) => api.put('/medi/consult/answer', params),
  newCount: () => api.get('/medi/consult/count'),
}
